import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Station Tickets
 * @returns {any} The result
 */
function LocationTickets() {
  const { t, i18n } = useTranslation('sidePanel');
  
  return <div dir={i18n.dir()}>{t('stationTickets')}</div>;
}

export default LocationTickets;
